/**
 * Учёт самостоятельной практики «Первых шагов» (E4.6a): открытый в учебном экземпляре
 * адрес customer-exports, узла карты или события EV-1042 отмечает действие только после показа карточки или инспектора.
 * Страницы, открытые туром, практикой не считаются -- и после выхода из тура на них, «Назад»
 * браузера и перезагрузки (tourPages): засчитывается только переход самого пользователя.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useWorkspaceDataSource } from '@/features/workspace/WorkspaceDataSourceContext';
import { practiceAt } from './catalog';
import { findTrainingTarget } from './targets';
import { recordPractice } from './progress';
import { isTourPage, leaveTourPages, markTourPage } from './tourPages';
import { useTourStore } from './tourStore';
import { useTrainingProgress } from './useTrainingProgress';

export function TrainingPracticeRecorder() {
	const { manifest } = useWorkspaceDataSource();
	const { pathname, search } = useLocation();
	const { progress, update } = useTrainingProgress();
	/* Страница, открытая туром, -- просмотр урока, а не самостоятельная практика */
	const touring = useTourStore(
		(state) => state.tour.phase !== 'idle' && state.tour.phase !== 'paused',
	);
	const here = `${pathname}${search}`;
	const practice =
		manifest === null || touring || isTourPage(here)
			? null
			: practiceAt(pathname, search, manifest);
	const done = practice !== null && progress.practice[practice] === true;

	useEffect(() => {
		if (touring) markTourPage(here);
		else leaveTourPages(here);
	}, [here, touring]);

	useEffect(() => {
		if (practice === null || done) return undefined;
		const record = () => {
			if (findTrainingTarget(practice === 'map' ? 'node' : practice))
				update((current) => recordPractice(current, practice));
		};
		record();
		const observer = new MutationObserver(record);
		observer.observe(document.body, { childList: true, subtree: true, attributes: true });
		return () => observer.disconnect();
	}, [done, practice, update]);

	return null;
}
